
//import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

//Vue.use(BootstrapVue);
//Vue.use(IconsPlugin);
import Vue from 'vue'
import { BVToastPlugin } from 'bootstrap-vue'

Vue.use(BVToastPlugin)
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
